import { IProduct } from "./product.types";

export enum ContestMaintenanceStatus {
  PENDING = "PENDING", 
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  IN_REVIEW = "IN_REVIEW"
}

export const STATUS_LABELS_CONTEST_MAINTENANCE: Record<ContestMaintenanceStatus, string> = {
  [ContestMaintenanceStatus.PENDING]: 'Pendente',
  [ContestMaintenanceStatus.APPROVED]: 'Aprovado',
  [ContestMaintenanceStatus.REJECTED]: 'Respondido',
  [ContestMaintenanceStatus.IN_REVIEW]: 'Em revisão',
};

export interface IContestMaintenanceDetail {
  _id: string;
  maintenanceId: string;
  productIds: string[];
  message: string;
  status: ContestMaintenanceStatus;
  createdBy: string;
  resolvedBy: string;
  resolution: string;
  createdAt: Date;
  updatedAt?: Date;
  resolvedAt?: Date;
	licensePlate: string;
}

export interface IContestMaintenance {
  _id: string;
  maintenanceId: string;
  productIds: string[];
  products?: IProduct[];
  message: string;
  status: ContestMaintenanceStatus;
	contestMaintenance?: IContestMaintenanceDetail; 
  createdBy: string;
  resolvedBy: string;
  resolution: string;
  createdAt: Date;
  updatedAt?: Date;
  resolvedAt?: Date;
	licensePlate: string;
	createdByName?: string;
}
